import { useEffect, useState } from "react";

// true mientras la tarjeta del formulario (#formulario) está visible en pantalla.
export const useFormInView = () => {
  const [inView, setInView] = useState(true);
  useEffect(() => {
    const el = document.getElementById("formulario");
    if (!el) return undefined;
    const obs = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return inView;
};
